export class ActivityQuestionUI {
  constructor(coursenum, activityId, qEditingDisabled) {
    this.coursenum = coursenum
    this.activityId = activityId
    this.qEditingDisabled = qEditingDisabled === 'True'
  }

  attach() {
    var self = this

    /**
     * Custom Event for triggering a section (question batch) to re-render
     */
    $('#question-batch-questions').on(
      'refresh_question_batch',
      (event, batchId) => {
        this.renderQuestionBatch(batchId)
      }
    )

    /**
     * Initial render of all the section (question batch) containers
     */
    $('.temporary-batch-container')
      .toArray()
      .forEach(el => {
        var container = $(el)
        var id = container.data('batch-id')
        this.renderQuestionBatch(id, container, true)
      })

    /**
     * Delegated click handler for question actions
     */
    $('#activity-questions-outer-container').on('click.batch_actions', evt => {
      var el = $(evt.target)

      if (el.hasClass('edit_question_button')) {
        evt.preventDefault()
        this.editorDialog(
          el.data('batch-id'),
          el.data('guid'),
          this.qEditingDisabled
        )
      } else if (el.hasClass('import_qti_button')){
        evt.preventDefault()
        this.importQTIDialog(
          el.data('batch-id'),
          el.data('guid'),
          this.qEditingDisabled
        )
      } else if (el.hasClass('add_question_button')) {
        evt.preventDefault()
        this.addNewQuestionDialog(
          el.data('batch-id'),
          el.data('guid'),
          this.qEditingDisabled
        )
      } else if (el.hasClass('icon_plus')) {
        evt.preventDefault()
        el = el.parent()
        this.addNewQuestionDialog(
          el.data('batch-id'),
          el.data('guid'),
          this.qEditingDisabled
        )
      } else if (el.hasClass('duplicate_question_button')) {
        evt.preventDefault()
        this.duplicateQuestion(
          el.data('batch-id'),
          el.data('guid'),
          this.qEditingDisabled
        )
      } else if (el.hasClass('RemoveQuestionButton')) {
        evt.preventDefault()
        this.removeQuestion(
          el.data('batch-id'),
          el.data('guid'),
          this.qEditingDisabled
        )
      } else if (el.hasClass('RemoveBatchButton')) {
        evt.preventDefault()
        this.deleteBatch(el.data('batch-id'))
      }
    })

    $('#activity-questions-outer-container').on(
      'click.convenience_edit',
      '.activity-question-item-inner',
      function (evt) {
        evt.stopPropagation()
        var el = $(this).parent()
        self.editorDialog(
          el.data('batch-id'),
          el.data('guid'),
          self.qEditingDisabled
        )
      }
    )

    /**
     * Quick scroll to question batch
     */
    $('#batch-bars').on(
      'click.quick-scroll',
      '.question-block-side-bar-link',
      function () {
        var batchId = $(this).data('batch-id')
        var $batch = $(`.batch-section-container[data-batch-id=${batchId}]`)
        $('body').scrollTo($batch.position().top)
      }
    )

    /**
     * Left bar sections can re-order with Drag-n-Drop
     */
    $('#batch-bars').sortable({
      axis: 'y',
      containment: '#batch-bars',
      helper: 'clone',
      update: (event, ui) => {
        var batchItem = ui.item
        var batchQuestions = $('#batch-' + batchItem.attr('data-batchid'))
        var nextBatchItem = batchItem.next()
        if (nextBatchItem.length === 0) {
          batchQuestions.parent().append(batchQuestions)
        } else {
          $('#batch-' + nextBatchItem.data('batchid')).before(batchQuestions)
        }

        batchItem
          .find('.question-block-side-bar-link')
          .trigger('click.quick-scroll')

        $('#batch-bars').powerTimer({
          delay: 500,
          name: 'sort_batch_bars',
          func: () => {
            var pks = $('#batch-bars > li')
              .toArray()
              .map(el => $(el).data('batchid'))
            $.ajax({
              url: `/instructor/activity_questions.order_question_batches/${this.coursenum}/${this.activityId}/`,
              type: 'POST',
              dataType: 'script',
              data: {
                pks: pks.join(','),
              },
            })
          },
        })
      },
    })
  }

  editorDialog(id, guid, qEditingDisabled) {
    if (qEditingDisabled) {
      $.meDialog.topMessage(
        'Question editing has been disabled for this course',
        5000,
        'warning'
      )
    } else {
      var url = `/instructor/activity_questions.question_editor/${this.coursenum}/${this.activityId}/${id}/${guid}`
      $.meDialog.open2({
        id: 'question_editor_dialog',
        url,
        title: 'Question Editor',
        width: 900,
      })
    }
  }

  importQTIDialog(id, guid, qEditingDisabled) {
    if (qEditingDisabled) {
      $.meDialog.topMessage(
        'Question editing has been disabled for this course',
        5000,
        'warning'
      )
    } else {
      var url = `/instructor/activity_questions.replace_question_with_qti_import/${this.coursenum}/${this.activityId}/${id}/${guid}`
      $.meDialog.open2({
        id: 'import_qti_dialog',
        url,
        title: 'Replace Question with QTI Import',
        width: 900,
      })
    }
  } 
  

  addNewQuestionDialog(id, guid, qEditingDisabled) {
    if (qEditingDisabled) {
      $.meDialog.topMessage(
        'Question editing has been disabled for this course',
        5000,
        'warning'
      )
    } else {
      var lastQtype =
        $.jStorage.get('instructor_canvas_last_activity_question_type') ||
        'multiplechoice'
      var url = `/instructor/activity_questions.question_editor/${this.coursenum}/${this.activityId}/${id}/${lastQtype}/${guid}`
      $.meDialog.open2({
        id: 'question_editor_dialog',
        url,
        title: 'Question Editor',
        width: 900,
      })
    }
  }

  duplicateQuestion(id, guid, qEditingDisabled) {
    if (qEditingDisabled) {
      $.meDialog.topMessage(
        'Question editing has been disabled for this course',
        5000,
        'warning'
      )
    } else {
      var url = `/instructor/activity_questions.duplicate_question/${this.coursenum}/${this.activityId}/${id}/${guid}`
      $.post(url, () => {
        this.renderQuestionBatch(id)
      })
    }
  }

  removeQuestion(id, guid, qEditingDisabled) {
    if (qEditingDisabled) {
      $.meDialog.topMessage(
        'Question editing has been disabled for this course',
        5000,
        'warning'
      )
    } else {
      var url = `/instructor/activity_questions.remove_question/${this.coursenum}/${this.activityId}/${id}/${guid}/1`
      $.post(url, () => {
        this.renderQuestionBatch(id)
      })
    }
  }

  deleteBatch(id, qEditingDisabled) {
    if (qEditingDisabled) {
      $.meDialog.topMessage(
        'Question editing has been disabled for this course',
        5000,
        'warning'
      )
    } else {
      var url = `/instructor/activity_questions.delete_batch/${this.coursenum}/${this.activityId}/${id}/`
      $.post(url, () => {
        location.reload()
      })
    }
  }

  getBatchContainer(id, qEditingDisabled) {
    if (qEditingDisabled) {
      $.meDialog.topMessage(
        'Question editing has been disabled for this course',
        5000,
        'warning'
      )
    } else {
      return $('#question-batch-section-' + id)
    }
  }

  renderQuestionBatch(batchId, container, initialRender = false) {
    if (!container) {
      container = this.getBatchContainer(batchId)
    }
    var getBatchUrl = `/instructor/activity_questions.get_batch/${this.coursenum}/${batchId}`

    var self = this
    $.get(getBatchUrl, function (data) {
      var el = $(data)
      container.replaceWith(el)

      el.collapsibleSection({ defaultState: 'opened' })
      self.makeQuestionListDraggable(el.find('.activity-question-list'))

      var color = el.data('custom-color')
      $('#question-block-side-bar-' + batchId).css({
        borderColor: color,
        backgroundColor: color,
      })
      el.find('.collapsible-section-title').css({
        borderColor: color,
        backgroundColor: color,
      })
      el.find('.collapsible-section-content').css({ borderColor: color })

      if (!initialRender) {
        self.incrementalUpdate(batchId)
      }
    })
  }

  /**
   * If rendering for a live update, do these additional things:
   *  - update the left bar number for questions-in-use
   *  - update the total number of quetions in use
   *  - fetch (AJAX) the points value of the Activity and set in the header
   */
  incrementalUpdate(batchId) {
    var num = $(`#question-batch-${batchId}-title-question-selection`).html()
    $(`#question-batch-${batchId}-question-selection`).html(num)

    var inUse = $('.batch-questions-in-use')
      .toArray()
      .map(el => parseInt($(el).html(), 10))
      .sum()
    $('#total-questions-in-use').html(inUse)

    $.get(
      `/instructor/activity.points/${this.coursenum}/${this.activityId}`,
      data => {
        $('#total-activity-points').html(data)
      }
    )
  }

  makeQuestionListDraggable(el) {
    var baseUrl = `/instructor/activity_questions.order_questions/${this.coursenum}/${this.activityId}/`

    $(el).sortable({
      helper: 'clone',
      appendTo: '#draggable_append_to',
      start: (e, ui) => {
        ui.item
          .closest('.activity-question-list')
          .powerTimer('stop', 'question_sort_order')
      },
      update: (e, ui) => {
        var qlist = ui.item.closest('.activity-question-list')
        qlist.powerTimer({
          delay: 500,
          name: 'question_sort_order',
          func: () => {
            var guids = qlist
              .find('.activity-question-item')
              .toArray()
              .map(el => $(el))
              .filter(el => el.attr('id'))
              .map(el => el.data('guid'))

            $.ajax({
              url: baseUrl + qlist.data('batch-id'),
              type: 'POST',
              dataType: 'script',
              data: {
                guids: guids.join(','),
              },
            })
          },
        })
      },
    })
  }
}
